export default function OnboardingHeader() {
  return (
    <div className={'bg-transparent px-5 pt-5 lg:px-10 lg:pt-10 lg:pb-5 flex gap-5'}>
      <div className="flex items-center gap-2">
        <img alt={'CreativeOS'} src={'/whiteCOSVector1.png'} className={'w-6'} />
        <span className="text-white font-bold">CreativeOS</span>
      </div>
    </div>
  )
}
